import { render, staticRenderFns } from "./TaskPhotos.vue?vue&type=template&id=08fa8a38"
import script from "./TaskPhotos.vue?vue&type=script&lang=js"
export * from "./TaskPhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports